exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-wrapper[data-v-180066a9]{margin-top:30px;background-color:#fff}.offset-header[data-v-180066a9]{top:-30px!important;margin:0 auto;max-width:calc(100% - 32px)}.header-card[data-v-180066a9]{top:-30px!important;margin:0 auto;max-width:calc(100% - 32px);min-height:20px;color:#fff;font-size:16px}.card-header[data-v-180066a9]{transition:all .3s ease-in-out}.headline[data-v-180066a9]{font-weight:200!important;font-size:16px!important}.v-card__title[data-v-180066a9]{padding:5px!important}", ""]);

// exports
